import axios from "axios";
import {getSignParams, getConfig} from "../utils";
import configEnv from "./config"
import { encryptCBC, decryptCBC } from '../utils/crypt'
let splitTimestamp = 0

getConfig()
const service = axios.create({
    baseURL: configEnv.env.VUE_APP_MA_BASE_API,
    timeout: 5000,
    withCredentials: true,
});
console.log(configEnv.env.VUE_APP_BASE_API, 'config')

service.interceptors.request.use(
    (config) => {
        const apiVersion =  config?.version || process.env.VUE_APP_API_VERSION_V1;
        const appVersion =  process.env.VUE_APP_APP_VERSION;
        let ak = configEnv.env.VUE_APP_OL_AK;
        let sk = configEnv.env.VUE_APP_OL_SK;
        const sign = getSignParams(config.url, {
            ak,
            sk,
            version: apiVersion,
            "api-version": apiVersion,
            split_timestamp: splitTimestamp
        });
        config.headers = {
            "Content-Type": "application/json",
            timestamp: sign.timestamp,
            appKey: sign.appKey,
            sign: sign.sign,
            version: sign.version,
            "api-version": apiVersion,
            "app-version": appVersion,
            "brandMdCode": configEnv.env.VUE_APP_BRAND === "COTTI" ? 20200000006 : 20200000007,
            split_timestamp: splitTimestamp,
        };
        const token = sessionStorage.getItem('COTTI_USER_TOKEN')
        if( token ) {
            config.headers.token = token
        }
        if (process.env.VUE_APP_ISCRYPT && process.env.VUE_APP_ISCRYPT != 0) {
            config.data = encryptCBC(JSON.stringify(config.data));
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        if (response.headers?.split_timestamp && Number(response.headers?.split_timestamp) > Number(splitTimestamp)) {
            splitTimestamp = response.headers.split_timestamp
        }
        if (process.env.VUE_APP_ISCRYPT && process.env.VUE_APP_ISCRYPT != 0) {
            try {
                const decryptedData = decryptCBC(response)
                response = decryptedData;
              } catch (error) {
                console.error('解密失败:', error);
              }
        }
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default service;
